import { render } from "./Presences.vue?vue&type=template&id=35f3fffe"
import script from "./Presences.vue?vue&type=script&lang=js"
export * from "./Presences.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__